var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.State.newPageLoading,
      expression: "State.newPageLoading"
    }],
    class: {
      black: _vm.State.pageLoading
    },
    attrs: {
      "id": "app"
    }
  }, [_vm.showChrome && !_vm.isChrome && !_vm.isAndroid && !_vm.isIos ? _c('div', {
    staticClass: "chromeTips"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.chromeSuggest')) + " "), _c('span', {
    on: {
      "click": _vm.closeChromeTips
    }
  }, [_vm._v(_vm._s(_vm.$t('common.gotIt')))])]) : _vm._e(), _c('Network', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.State.networkConnect,
      expression: "!State.networkConnect"
    }]
  }), _c('div', {
    staticClass: "router-con"
  }, [_c('router-view', {
    attrs: {
      "name": "head"
    }
  }), _c('div', {
    staticClass: "page-content"
  }, [_c('router-view')], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };